import {Button} from '@primer/react'
import {type RefObject, Suspense, useCallback, useState} from 'react'

import type {CreateLinkedBranchRequest} from '../../../mutations/create-linked-branch-mutation'
import {type BranchNextStep, CreateBranchDialog} from './CreateBranchDialog'
import styles from './NoBranchesOrLinkedPullRequests.module.css'

type NoBranchesOrLinkedPullRequestsProps = {
  issueId: string
  title: string
  number: number
  owner: string
  repo: string
  before?: string
  after?: string
  linkText: string
  reportCreateBranchDialogOpen: (isOpen: boolean) => void
  onSubmitCreateBranch: (request: CreateLinkedBranchRequest, nextStep: BranchNextStep) => void
  returnFocusRef?: RefObject<HTMLElement | null>
  createBranchDisabled?: boolean
}

export function NoBranchesOrLinkedPullRequests({
  issueId,
  title,
  number,
  owner,
  repo,
  before,
  after,
  linkText,
  reportCreateBranchDialogOpen,
  onSubmitCreateBranch,
  returnFocusRef,
  createBranchDisabled = false,
}: NoBranchesOrLinkedPullRequestsProps) {
  const [isCreateBranchDialogOpen, setCreateBranchDialogOpen] = useState(false)

  const onCreateBranchDialogClose = useCallback(() => {
    setCreateBranchDialogOpen(false)
    reportCreateBranchDialogOpen(false)
  }, [reportCreateBranchDialogOpen])

  return (
    <>
      {before}
      {before && ' '}
      <Button
        variant="link"
        disabled={createBranchDisabled}
        onClick={() => {
          reportCreateBranchDialogOpen(true)
          setCreateBranchDialogOpen(true)
        }}
        className={styles.createBranchLink}
      >
        {linkText}
      </Button>
      {after && ' '}
      {after}
      {isCreateBranchDialogOpen && (
        <Suspense>
          <CreateBranchDialog
            issueId={issueId}
            title={title}
            number={number}
            owner={owner}
            repo={repo}
            onClose={onCreateBranchDialogClose}
            onSubmit={onSubmitCreateBranch}
            returnFocusRef={returnFocusRef}
          />
        </Suspense>
      )}
    </>
  )
}
